import { useState, useEffect, useCallback } from 'react';
import { LOOKUPS_KEY } from '../localStorageKeys';
import { CategoryEnum } from '../../AdminPortal/scenes/Lookup/enums';

export const useLookupOptions = () => {
  const [specializationList, setSpecializationList] = useState<string[]>([]);
  const [careerLevelList, setCareerLevelList] = useState<string[]>([]);
  const [employmentTypeList, setEmploymentTypeList] = useState<string[]>([]);
  const [qualificationList, setQualificationList] = useState<string[]>([]);
  const [countryList, setCountryList] = useState<string[]>([]);
  const [languageList, setLanguageList] = useState<string[]>([]);
  const [contractTypeList, setContractTypeList] = useState<string[]>([]);
  const [skillList, setSkillList] = useState<string[]>([]);
  const [industryList, setIndustryList] = useState<string[]>([]);
  const [companySizeList, setCompanySizeList] = useState<string[]>([]);
  const [interviewerAvatarList, setInterviewerAvatarList] = useState<string[]>([]);
  const [interviewerVoiceList, setInterviewerVoiceList] = useState<string[]>([]);
  
  const refreshLookups = useCallback(() => {
    const lookups = localStorage.getItem(LOOKUPS_KEY) || '{}';
    const lookupsJSON = JSON.parse(lookups);
    const setters: { [key: string]: React.Dispatch<React.SetStateAction<string[]>> } = {
      [CategoryEnum[CategoryEnum.SPECIALIZATION]]: setSpecializationList,
      [CategoryEnum[CategoryEnum.COUNTRY]]: setCountryList,
      [CategoryEnum[CategoryEnum.CAREER_LEVEL]]: setCareerLevelList,
      [CategoryEnum[CategoryEnum.CONTRACT_TYPE]]: setContractTypeList,
      [CategoryEnum[CategoryEnum.EMPLOYMENT_TYPE]]: setEmploymentTypeList,
      [CategoryEnum[CategoryEnum.LANGUAGE]]: setLanguageList,
      [CategoryEnum[CategoryEnum.QUALIFICATION]]: setQualificationList,
      [CategoryEnum[CategoryEnum.SKILL]]: setSkillList,
      [CategoryEnum[CategoryEnum.INDUSTRY]]: setIndustryList,
      [CategoryEnum[CategoryEnum.COMPANY_SIZE]]: setCompanySizeList,
      [CategoryEnum[CategoryEnum.INTERVIEWER_AVATAR]]: setInterviewerAvatarList,
      [CategoryEnum[CategoryEnum.INTERVIEWER_VOICE]]: setInterviewerVoiceList,
    };

    const categoryKeys = Object.keys(CategoryEnum).filter(key => isNaN(Number(key)));
    categoryKeys.forEach(categoryName => {
      const setter = setters[categoryName];
      if (setter && lookupsJSON[categoryName]) {
        setter(lookupsJSON[categoryName].map((item: { value: string }) => item.value));
      }
    });
  }, []);

  useEffect(() => {
    refreshLookups();
  }, []);

  return {
    specializationList,
    careerLevelList,
    employmentTypeList,
    skillList,
    qualificationList,
    countryList,
    languageList,
    contractTypeList,
    industryList,
    companySizeList,
    interviewerAvatarList,
    interviewerVoiceList,
    refreshLookups
  };
};